export default __webpack_public_path__ + "static/media/user.511c2b09.svg";